module.exports = __webpack_public_path__ + "static/media/mal_seculo.738c19e3.jpg";